// Generated by purs version 0.14.5
"use strict";
var otherwise = true;
module.exports = {
    otherwise: otherwise
};
